import { render, staticRenderFns } from "./QuickTips.vue?vue&type=template&id=93c368f0&scoped=true&"
import script from "./QuickTips.vue?vue&type=script&lang=js&"
export * from "./QuickTips.vue?vue&type=script&lang=js&"
import style0 from "./QuickTips.vue?vue&type=style&index=0&id=93c368f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c368f0",
  null
  
)

export default component.exports